import { RootState } from 'app/store/rootReducer';
import { selectIsInFirstStepMode } from 'app/store/data/formsConfig';
import {
  isPrerendering,
  wasPrerendered,
} from 'app/shared/helpers/isPrerendering';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';

// isInFirstStepMode is only ever set by the car calculation flow, so on any other
// route it stays undefined forever - the prerender fallback must not leak there.
export const selectIsFirstStepModeView = (state: RootState) => {
  const isInFirstStepMode = selectIsInFirstStepMode(state);

  if (isInFirstStepMode === undefined) {
    return (
      (isPrerendering || !!wasPrerendered) &&
      selectIsFormMicroCenterActive(state)
    );
  }

  return isInFirstStepMode;
};
